module.exports = __webpack_public_path__ + "img/big_11B21_blue.cef45ca1.png";